import { useFragment } from "@apollo/client";

import { SearchSuggestionsInput, SearchSuggestionsOutput } from "types/generated";

import useSpaceliftVcsReposFiltersVariables from "./useFiltersVariables";
import { SEARCH_SPACELIFT_VCS_REPOS_SUGGESTIONS_FILTERED_COUNT_FRAGMENT } from "./gql";

const useAllItemsCount = () => {
  const { fullTextSearch, predicates } = useSpaceliftVcsReposFiltersVariables();

  const { data } = useFragment<
    { searchReposSuggestions: Pick<SearchSuggestionsOutput, "filteredCount"> },
    { input: SearchSuggestionsInput }
  >({
    fragment: SEARCH_SPACELIFT_VCS_REPOS_SUGGESTIONS_FILTERED_COUNT_FRAGMENT,
    from: {
      __typename: "Query",
    },
    variables: {
      input: {
        fullTextSearch,
        predicates,
        fields: null,
      },
    },
  });

  const allItemsCount = data?.searchReposSuggestions?.filteredCount || 0;

  return {
    allItemsCount,
  };
};

export default useAllItemsCount;
